import { z } from "zod";

export const CreatePromptSchema = z.object({
  name: z.string().min(1)
});

export const UpdatePromptSchema = z.object({
  name: z.string().min(1).optional(),
  content: z.string().min(1).optional(),
  isActive: z.boolean().optional()
});
